module.exports = __webpack_public_path__ + "media/assets/avatars/a-san-img-61537f9100f852223baaea66569ee5c9.svg";